import React from "react";

import { Box, Typography } from "@mui/material";

const EmptyState = ({
  title,
  imageWidth,
  imageHeight,
  children,
  top,
  useImg2,
  sx = {},
}) => {
  return (
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      sx={{ ...sx }}
    >
      {/* Image */}
      <Box
        component="img"
        src={
          useImg2
            ? null
            : "https://firebasestorage.googleapis.com/v0/b/getgeek-7c6f1.appspot.com/o/Empty.png?alt=media&token=169fc65d-c635-4258-8d72-f660f39dc72a"
        }
        width={imageWidth || "auto"}
        height={imageHeight || "400px"}
        draggable={false}
      />

      {/* Overlay Container for Text */}
      <Box
        position="absolute"
        top={top ? top : "27%"} // Adjust this to position the text correctly
        width="350px" // Adjust to match the width of the banner
        height="90px" // Match the height of the banner
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="8px"
        textAlign="center"
      >
        <Typography
          fontFamily="Outfit"
          fontSize="18px"
          fontWeight="500"
          color="#7D7D7D"
          px={2}
        >
          {title || "No assessments available at the moment."}
        </Typography>
      </Box>

      {children}
    </Box>
  );
};

export default EmptyState;
